<style>
  .Special {
    background-color: #ff9595 !important;
  }

  .DeviceBazgasht {
    background-color: #fff895 !important;
  }

  .DeviceBazgashtAll {
    background-color: #ff9c95 !important;
  }
</style>
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">آرشیو نامه</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نوع نامه</label>
          <select class="custom-select" [(ngModel)]="LetterType_Filter">
            <option value="0">همه موارد</option>
            <option value="1">نامه وارده</option>
            <option value="2">نامه صادره</option>
            <option value="3">رسید امانت</option>
            <option value="4">رسید امانت</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">موضوع نامه</label>
          <select class="custom-select" [(ngModel)]="Subject_Filter">
            <option value="0">همه موارد</option>
            <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="LetterNumber_Filter" name="LetterNumber_Filter" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام دستگاه</label>
          <input [(ngModel)]="DeviceName_Filter" name="DeviceName_Filter" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 mb-30">

          <div class="card card-statistics">
            <div class="card-body">
              <h5 class="card-title" *ngIf="!Procssing"> مشتریان ({{DataList_Customer.length}} مورد)</h5>
              <h5 class="card-title" *ngIf="Procssing"> مشتریان (در حال بارگذاری ...)</h5>
              <!-- action group -->

              <div class="scrollbar" style="max-height: 500px;">
                <ul class="list-unstyled">
                  <li class="mb-15" *ngFor="let item of DataList_Customer
              | paginate: {
                  id: 'DataList_CustomerTable',
                  itemsPerPage: 6,
                  currentPage: page,
                  totalItems: DataList_Customer.length
                }" [ngClass]="{'Special': item.special}" style="cursor: pointer;"
                    (click)="Set_Customer_For_Letter(item)">
                    <div class="media">

                      <div class="media-body">
                        <h6 *ngIf="!item.selected" class="mt-0 "> {{item.name}} <small
                            class="float-right">{{item.code}}</small> </h6>
                        <h6 *ngIf="item.selected"
                          style="text-decoration: underline;font-style: italic;font-weight: bold;" class="mt-0 ">
                          {{item.name}} <small class="float-right">{{item.code}}</small> </h6>
                        <p>{{item.modirAmelName}}</p>
                      </div>
                    </div>
                    <div class="divider mt-15"></div>
                  </li>

                </ul>
              </div>
              <pagination-controls id="DataList_CustomerTable" nextLabel="بعدی" previousLabel="قبلی"
                (pageChange)="page = $event"></pagination-controls>
            </div>
          </div>
        </div>
        <div class="col-xl-9 mb-30">

          <div class="card tickets">
            <div class="card-body">
              <h5 class="card-title" *ngIf="Select_Data_Customer.id>0">نامه های مشتری ' {{Select_Data_Customer.name}} '
              </h5>
              <h5 class="card-title" *ngIf="Select_Data_Customer.id==0">نامه های مشتری 'مشتری انتخاب نشده است'</h5>

              <br />
              <div class="scrollbar max-h-550 tickets-info" *ngIf="Select_Data_Customer.id>0">

                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>شناسه</th>
                        <th>نامه</th>
                        <th>نوع</th>
                        <th>موضوع </th>
                        <th>فرستنده</th>
                        <th>گیرنده</th>
                        <th>وضیعت</th>
                        <th>پیام</th>
                        <th>پیوست</th>
                        <th>تاریخ</th>
                        <th>امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item2 of DataList_LetterRequestCustomer
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 6,
                              currentPage: page2,
                              totalItems: (DataList_LetterRequestCustomer).length
                            }
                  " [ngClass]="{'DeviceBazgashtAll': item2.lastSection_Id===25,'DeviceBazgasht': item2.bazgasht===true}">
                        <td>{{DataList_LetterRequestCustomer.indexOf(item2)+1}}</td>
                        <td>{{item2.letterCode}}</td>
                        <td>{{item2.code}}</td>
                        <td>{{item2.letterType}}</td>
                        <td>{{item2.subject_name}}</td>

                        <td>{{item2.lastSender}}</td>
                        <td>{{item2.lastGiver}}</td>
                        <td>{{item2.lastSection}}</td>
                        <td>{{item2.lastOrder}}</td>
                        <td>
                          <i *ngIf="item2.peyvaset" class="fa fa-check" style="color: green;"></i>
                          <i *ngIf="!item2.peyvaset" class="fa fa-times" style="color: red;"></i>
                          <i *ngIf="item2.sms" class="fa fa-envelope" style="color: blue;"></i>
                          <i *ngIf="item2.codePeygiri" class="fa fa-money" title="{{item2.codePeygiri}}"
                            style="color: blue;"></i>
                        </td>
                        <td>{{item2.persianDate}}</td>
                        <td>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='رسید امانت'"
                            [routerLink]="['/LetterRequestCustomerPreOrder',{id:item2.id}]"><i class="fa fa-edit"></i>
                            مشاهده </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='نامه وارده'"
                            [routerLink]="['/LetterRequestCustomerDraftForm',{id:item2.id}]"><i class="fa fa-edit"></i>
                            مشاهده </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='نامه صادره'"
                            [routerLink]="['/LetterRequestCustomerForm',{id:item2.id}]"><i class="fa fa-edit"></i>
                            مشاهده </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='درخواست کالیبراسیون'"
                            [routerLink]="['/LetterRequestCustomerCalibration',{id:item2.id}]"><i
                              class="fa fa-edit"></i> مشاهده </a>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی"
                  (pageChange)="page2 = $event"> </pagination-controls>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>